module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    staticClass: "orange pa-2",
    attrs: {
      "slot": "activator",
      "dark": "",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "white--text text--lighten-1"
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "cyan--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/victorium_logo.png"
    }
  })])], 1), _vm._v(" "), (_vm.error) ? _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('p', {
    staticClass: "grey--text"
  }, [_vm._v("Administrator Login")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignin($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Password",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "xs4": "",
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "cyan white--text",
    attrs: {
      "xs4": "",
      "type": "submit",
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "depressed": ""
    }
  }, [_vm._v("\n                    Log In\n                    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c2d7db6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/SignIn.vue
// module id = 701
// module chunks = 1